import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { CommonService } from "../../shared/services/common.service";
import { CustomerService } from "../services/customer.service";
import { DeleteModal } from "../models/delete-modal";
import { MessageService } from "../../shared/services/message.service";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { NgProgress } from "ngx-progressbar";
import { CommonMessage } from "../common/common-messages";
import { CreateTicketRequest } from "../interface/ticketingsystem/ticket-create";
import { TicketResponseModel } from "../interface/ticketingsystem/ticket-response.model";
import { NoteModel } from "../interface/ticketingsystem/note.model";
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MemberType } from "../common/constants";
import { Modal } from "ngx-modal";
import { DepartmentService } from "./../services/department.service";
import { Permission } from "../../common/enums/permission.enum";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { Status } from '../enums/ticket-status.enum';
import { SubtypesEnums, DisputeTypesEnums, SourceType, TicketType} from '../enums/ticket-type.enum';
import { Utils } from "../../shared/Utils/utils";
import { NotificationType } from '../enums/notification-types.enum';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from "../../shared/services/cache.service";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { DisputeReason } from "../enums/dispute-reason.enum";
import { CommonConstant } from "../../shared/constants/common.constants";
@Component({
    selector: "view-work-ticket",
    templateUrl: "../templates/template1/views/view-work-ticket.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ]
})

export class ViewWorkTicketComponent implements OnInit {
    @Input() ticketId: any;
    @Input() ticketinputvalue: any;
    @Input() isView: any;

    ticketEditForm: FormGroup;
    ticketCloseForm: FormGroup;
    isDesc:Boolean=true;     
    sortColumn:String;
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];

    isTicketCreate: boolean;
    isTicketAssign: boolean;
    isTicketAddNoteNotes: boolean;
    isTicketView: boolean;

    ticketingModel: any;
    noteModel: any;
    showViewTicket: boolean = false;
    showEditTicket: boolean = false;
    active: boolean = true;
    showHistory: boolean = true;
    uploader: any;
    uploadResponse: any = [];
    note: string;
    id: any;

    sourceTypes: any[];
    ticketPriorities: any[];
    ticketTypes: any[];
    subTypes: any[];
    statusTypes: any[];
    orderTypeId: number;
    productTypeId: number;
    users: any[];
    closedReasons: any[];
    departments: any[];

    userInfo: UserInfo;
    userId: number;
    showOrderField: boolean;
    _id: number;
    date: string;
    isTicketClosed: boolean;
    count: number = 0;
    isTicketClosePermission: boolean;
    isTicketReopenPermission: boolean;
    isTicketEditPermission: boolean;
    isTicketAssignPermission: boolean;
    isTicketReAssignPermission: boolean;
    isTicketSelfAssignPermission: boolean;
    deleteModal: DeleteModal;

    isInprogress: boolean;
    existFiles: any = [];
    isDisputeTicket: boolean = false;
    items: any[] = [];
    disputeReasons: any;
    disputeOrder: number = DisputeTypesEnums.Dispute_Total_Order;
    individualDisputeOrder: number = DisputeTypesEnums.Dispute_Individual_Order;
    isEntireOrder: boolean = false;
    individualOrderType = false;
    entireOrderType = false;
    orderInfo: any;
    orderSummary: any;
    isSubmitted: boolean = false;
    locationTypes: any;
    showLocationTypeField: boolean = false;
    //formInvalid:boolean = false; 
    qtyWarning: DeleteModal;
    invalidQtyLineItems: string;
    showDisputeReasonField: boolean = false;
    @ViewChild('focusNotes') focusNotes: ElementRef;
    @ViewChild('focusPriority') focusPriority: ElementRef;
    sourceTypesEnum:any = [SourceType.Phone, SourceType.Email];
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
        Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN
    ];

    @ViewChild('closeTicketModal') closeTicketPopup: Modal;
    @ViewChild('ticketActivityDetailsModal') ticketActivityDetailsModal: Modal;
    ticketActivityLogList: any[] = [];
    ticketActivityChangeData: String = "";
    bsValue:any;
    customerServiceAccessLevelId: number= AccessLevel.Customer_Service;
    phoneNumberFormat = CommonConstant.DefaultPhoneNumberFormat;
    
    constructor(private _cacheService: CacheService,
        private _datePipe: DatePipe, private _formbulider: FormBuilder,
        private departmentService: DepartmentService,
        private _translatePipe: TranslateService,
        private _commonService: CommonService,
        private _customerservice: CustomerService,
        private messageService: MessageService,
        private ngProgress: NgProgress) {

    }
    ngOnInit(): void {
        this.ticketingModel = new TicketResponseModel();
        this.noteModel = new NoteModel();
        this.closeForm();
        this.showViewTicket = this.isView === true ? true : false;
        this.showEditTicket = this.isView === true ? false : true;
        if (this.isView === "true") {
            this.getTicketById(this.ticketId, true);
        } else {
            this.getTicketById(this.ticketId, false);
        }
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        
        this._commonService.getUserInformation(this.userInfo.userName).subscribe(data => {        
            if(data){
                this._cacheService.set(CacheKey.UserInfo,data);
                this.userInfo = data;
                this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"),AccessLevel.Customer_Service);
                this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"),AccessLevel.Customer_Service);
                this.isTicketAddNoteNotes = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[2] + "]"),AccessLevel.Customer_Service);
                this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"),AccessLevel.Customer_Service);
            }
        });            
        this._id = this.ticketId;
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.qtyWarning = new DeleteModal(this.proceedToSave.bind(this),
            this.cancel.bind(this), this.cancel.bind(this));
        this.qtyWarning.viewActionButtons = true;
        this.date = this._datePipe.transform(new Date(), 'yyyy-MM-dd');
        this.active = false;
        this.showHistory = true;
        this.getSourceTypes();
        this.getTicketActivityLog();

        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.getDisputeReasons();
        this.getLocationTypes();
        
    }

    sortTableByColumn(property:any){
    this.isDesc = !this.isDesc; //change the direction    
    this.sortColumn = property;
    let direction = this.isDesc ? 1 : -1;

   this.ticketActivityLogList.sort(function(a, b){
        if(a[property] < b[property]){
            return -1 * direction;
        }
        else if( a[property] > b[property]){
            return 1 * direction;
        }
        else{
            return 0;
        }
    });
};
    /**
     * display alert box on reaching maximum no of attachmens = 5
     */
    displayAlertBoxOnReachingMaxAttachments() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.attachmentMessage;
    }

    displayAlertBoxOnNoPermissiononCloseTicket() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noCloseTicketPermissionMessage;
    }
    displayAlertBoxOnNoPermissiononReopenTicket() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noReopenTicketPermissionMessage;
    }

    doNotRemoveFormData() {
        //data should not be removed...
    }
    editForm() {

        this.ticketEditForm = this._formbulider.group(
            {
                dueDate: [this.ticketingModel.dueDate, this.ticketingModel.assignedToId ? Validators.required :null],
                ticketType: [{ value: this.ticketingModel.typeId, disabled: (this.isInprogress || this.isDisputeTicket) }, [Validators.required]],
                subType: [{ value: this.ticketingModel.subTypeId, disabled: this.isInprogress }, [Validators.required]],
                priority: [this.ticketingModel.priorityId, [Validators.required]],
                note: [""],
                assignedTo: [{ value: this.ticketingModel.assignedToId, disabled: !this.assignToPermission }],
                assignToMe: [false],
                orderId: [{ value: "", disabled: (this.isInprogress || this.isDisputeTicket) }, [Utils.numericCharacterValidation]],
                department: [{ value: this.ticketingModel.departmentId, disabled: this.isInprogress }, [Validators.required]],
                subject: [{ value: this.ticketingModel.subject, disabled: this.isInprogress }, [Validators.required]],
                description: [{ value: this.ticketingModel.description, disabled: this.isInprogress }],
                status: [{ value: this.ticketingModel.statusId, disabled: true }, [Validators.required]],
                items: this._formbulider.array(this.items),
                orderReasonReasonId: [this.ticketingModel.orderReasonReasonId],
                locationTypeId: [this.ticketingModel.locationTypeId],
                orderReasonNotes: [this.ticketingModel.orderReasonNotes]
            });
            if(this.ticketingModel.dueDate)
               this.bsValue=new Date(this.ticketingModel.dueDate);
        this.ticketingModel.assignedToId
            ? this.ticketingModel.assignedToId === this.userInfo.userId ? this.ticketEditForm.controls["assignToMe"].setValue(true) : this.ticketEditForm.controls["assignToMe"].setValue(false)
            : this.ticketEditForm.controls["assignToMe"].setValue(false);
        this.showDisputeReasonField = false;
        if (this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Total_Order && this.ticketingModel.orderReasonReasonId === DisputeReason.Other) {
            this.ticketEditForm.controls['orderReasonNotes'].setValidators([Validators.required]);
            this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
            this.showDisputeReasonField = true;
        }
        else if (this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
            let disputes: any[] = this.ticketEditForm.getRawValue().items;
            if (disputes.find(item => item.ticketDisputeReasonId === DisputeReason.Other)) {
                this.ticketEditForm.controls['orderReasonNotes'].setValidators([Validators.required]);
                this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
                this.showDisputeReasonField = true;
            }
        }
    }
    attachmentsLength: number = 0;
    checkMaxAttachments() {
        if (this.uploader.queue) {
            this.attachmentsLength = this.existFiles.length + this.uploader.queue.length;
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
                this.displayAlertBoxOnReachingMaxAttachments();
            }
        }

    }
    checkAssignToMe(event: any) {
        let isChecked = this.ticketEditForm.getRawValue().assignToMe;
        if (this.ticketingModel.assignedToId && !isChecked) {
            this.ticketEditForm.controls["assignedTo"].setValue(this.ticketingModel.assignedToId);
        } else if (isChecked) {
            this.ticketEditForm.controls["assignedTo"].setValue(this.userInfo.userId);
        } else {
            this.ticketEditForm.controls["assignedTo"].setValue('');
        }
        this.setValidatorsForDueDate(isChecked ? true: false);
    }
    onAssignToChange(event: any) {
        let assignTo = this.ticketEditForm.getRawValue().assignedTo;
        if (assignTo && assignTo === this.userInfo.userId) {
            this.ticketEditForm.controls["assignToMe"].setValue(true);
        } else {
            this.ticketEditForm.controls["assignToMe"].setValue(false);
        }
        this.setValidatorsForDueDate(assignTo ? true: false);
    }
    /*
set validations for Due date
*/
    setValidatorsForDueDate(isRequired: boolean) {
        if (isRequired) {
            this.ticketEditForm.controls['dueDate'].setValidators(Validators.required);
            this.ticketEditForm.controls['dueDate'].updateValueAndValidity();
        }
        else {
            this.ticketEditForm.controls['dueDate'].setValue('');
            this.ticketEditForm.controls['dueDate'].setValidators(null);
            this.ticketEditForm.controls['dueDate'].updateValueAndValidity();
        }
    }
    removeExistFiles(key: any, index: number) {
        this.existFiles.splice(index, 1);
        this.attachmentsLength = this.attachmentsLength - 1;
    }
    getTicketTypesAndSubTypes() {
        if (this.ticketingModel.operatingCountryId) {
            this.departmentService.getTicketTypesAndSubTypes(this.ticketingModel.operatingCountryId).subscribe(response => {
                if (response) {
                    this.ticketTypes = response;
                    const orderType = response.find((type: any) => type.value === TicketType.Order);
                    if (orderType) {
                        this.orderTypeId = orderType.id;
                    }
                    const productType = response.find((type: any) => type.value === TicketType.Product);
                    if (productType) {
                        this.productTypeId = productType.id;
                    }
                }
            });
        }
    }

    createItemNumberGroup(productInfo: any): FormGroup {
        let form: FormGroup;
        form = this._formbulider.group({
            itemNumber: [productInfo.itemNumber],
            quantity: [productInfo.quantity],
            productDescription: [productInfo.productDescription],
            alreadyDisputedQuantity: [productInfo.alreadyDisputedQuantity],
            newDisputedQuantity: ['0'],
            ticketDisputeReasonId: [productInfo.ticketDisputeReasonId ? productInfo.ticketDisputeReasonId : ""],
            include: [false],
            createdBy: [productInfo.createdBy],
            modifiedBy: [this.userInfo.userId],
            id: [productInfo.id]
        });
        if (productInfo.include) {
            form.controls['ticketDisputeReasonId'].setValidators([Validators.required]);
            form.controls['ticketDisputeReasonId'].updateValueAndValidity();
        }
        return form;
    }

    CreateIndividualOrderForm() {
        this.items = [];
        for (let index = 0; index < this.ticketingModel.disputes.length; index++) {
            this.items.push(this.createItemNumberGroup(this.ticketingModel.disputes[index]));
        }
    }
    editTicket() {
        this.isEntireOrder = false;
        this.items = [];
        this.showViewTicket = false;
        this.showEditTicket = true;
        this.isInprogress = this.ticketingModel.statusId === Status.InProgress ? true : false;
        this.editForm();
        this.getSubTypes(this.ticketingModel.typeId, false);
        this.uploader.queue = [];
        this.attachmentsLength = this.existFiles.length;

        if (this.isDisputeTicket) {
            this.ticketEditForm.controls["orderId"].setValue(this.ticketingModel.orderId);
            this.ticketEditForm.controls['orderId'].setValidators([Validators.required]);
            this.ticketEditForm.controls['orderId'].updateValueAndValidity();
        }
        else {
            this.ticketEditForm.controls["orderId"].setValue(this.ticketingModel.orderId);
        }

        if (this.uploader) {
            this.uploader.queue = [];
        } else {
            this.uploader = [];
        }

        this.attachmentsLength = this.existFiles.length;
        if (this.focusPriority && this.focusPriority.nativeElement)
            this.focusPriority.nativeElement.focus();
    }
    openCloseTicketModal(isCloseTicket: boolean) {
        if (!this.userInfo.hasSystemRole) {
            if (this.ticketingModel.assignedToId === (this.userInfo.userId)) {
                this.closeForm();
                this.closeTicketPopup.open();
                this.getClosedReasons();
            } else {
                if (isCloseTicket) {
                    this.displayAlertBoxOnNoPermissiononCloseTicket();
                } else {
                    this.displayAlertBoxOnNoPermissiononReopenTicket();
                }
            }
        } else {
            this.closeForm();
            this.closeTicketPopup.open();
            this.getClosedReasons();
        }


    }
    cancelPopup() {
        this.isSubmitted = false;
        this.closeTicketPopup.close();
    }
    closeTicket() {
        this.isSubmitted = true;
        if (this.ticketCloseForm.valid) {
            let createTicketValues: any = this.ticketCloseForm.getRawValue();
            let saveTicket = new CreateTicketRequest();
            if (this.isTicketClosed) {
                saveTicket.reopenReason = createTicketValues.closedTicketNote;
                saveTicket.ticketId = this.ticketingModel.id;
                saveTicket.userId = this.userInfo.userId;
                this.reopenTicketById(this.ticketingModel.id, saveTicket);
            } else {
                saveTicket.closeReasonId = createTicketValues.closedTicketReason;
                saveTicket.closeReason = createTicketValues.closedTicketNote;
                saveTicket.id = this.ticketingModel.id;
                saveTicket.userId = this.userInfo.userId;
                this.closeTicketById(this.ticketingModel.id, saveTicket);
            }
            this.cancelPopup();
        }
    }
    closeForm() {
        if (this.isTicketClosed) {
            this.ticketCloseForm = this._formbulider.group(
                {
                    closedTicketReason: [''],
                    closedTicketNote: ['', [Validators.required]]
                });
        } else {
            this.ticketCloseForm = this._formbulider.group({
                closedTicketReason: ['', [Validators.required]],
                closedTicketNote: ['']
            });
        }

    }
    getClosedReasons() {
        this._customerservice.getClosedReasons().subscribe((response) => {
            if (response) {
                this.closedReasons = response;
            }
        });
    }

    changeDisputedQty(items: any[]) {
        let disputes: any = items;
        items.forEach(item => {
            if (item.include) {
                item.alreadyDisputedQuantity = item.alreadyDisputedQuantity + (+item.newDisputedQuantity);
            }
            else {
                let disputes: any[] = this.ticketingModel.disputes
                let oldRecord = disputes.find(res => res.id === item.id);
                if (oldRecord && oldRecord.include) {
                    item.include = true;
                }
                else {
                    item.ticketDisputeReasonId = null;
                }
            }
            item.newDisputedQuantity = 0;
        });
        return items;
    }

    updateTicket() {

        let createTicketValues: any = this.ticketEditForm.getRawValue();
        let saveTicket = new CreateTicketRequest();

        if (this.isDisputeTicket && +createTicketValues.disputeType === DisputeTypesEnums.Dispute_Individual_Order) {
            saveTicket.disputes = this.changeDisputedQty(createTicketValues.items);
        }
        if (this.isDisputeTicket && +createTicketValues.disputeType === DisputeTypesEnums.Dispute_Total_Order) {
            saveTicket.orderReasonReasonId = createTicketValues.orderReasonReasonId;
        }
        saveTicket.sourceId = this.ticketingModel.sourceId;
        saveTicket.callerName = this.ticketingModel.callerName;
        saveTicket.typeId = createTicketValues.ticketType;
        saveTicket.subTypeId = createTicketValues.subType;
        saveTicket.note = createTicketValues.note;
        saveTicket.description = createTicketValues.description;
        saveTicket.departmentId = createTicketValues.department;
        saveTicket.priorityId = createTicketValues.priority;
        saveTicket.dueDate = createTicketValues.dueDate;
        saveTicket.subject = createTicketValues.subject;
        saveTicket.memberId = this.ticketingModel.memberId;
        saveTicket.memberType = MemberType.FOB;
        saveTicket.id = this.ticketingModel.id;
        saveTicket.ticketNumber = this.ticketingModel.ticketNumber;
        saveTicket.sourceIdentifierValue = this.ticketingModel.sourceIdentifierValue;
        saveTicket.createdBy = this.ticketingModel.createdBy;
        saveTicket.updatedBy = this.userInfo.userId;

        saveTicket.userId = this.userInfo.userId;
        saveTicket.firstName = this.userInfo.firstName;
        saveTicket.lastName = this.userInfo.lastName;
        if (createTicketValues.assignedTo) {
            saveTicket.assignedToId = +createTicketValues.assignedTo;
        } else if (createTicketValues.assignToMe) {
            saveTicket.assignedToId = this.userInfo.userId;
        }
        saveTicket.notes = this.ticketingModel.notes;
        saveTicket.statusId = saveTicket.assignedToId ? Status.InProgress : saveTicket.statusId = Status.New;
        saveTicket.operatingCountryId = this.ticketingModel.operatingCountryId;
        if (saveTicket.typeId === this.orderTypeId) {
            saveTicket.orderId = createTicketValues.orderId;
        }
        if (+(saveTicket.typeId) === this.productTypeId) {
            saveTicket.locationTypeId = createTicketValues.locationTypeId;
        }
        saveTicket.orderReasonNotes = this.showDisputeReasonField ? createTicketValues.orderReasonNotes : '';
        this.updateTicketById(this.ticketingModel.id, saveTicket);
    }
    updateTicketById(ticketId: number, saveTicket: any) {
        this._customerservice.updateTicketById(ticketId, saveTicket).subscribe(response => {
            if (response) {
              
                this.messageService.setDisputeTickets(true);
                if (this.uploader.queue.length > 0) {
                    this.uploadFile();
                }
                else if (this.ticketingModel.attachments.length !== this.existFiles.length) {
                    let temp: any = [];
                    this.saveAttachments(temp);
                }
                else {
                    let addedNotification: any = this._translatePipe.get("Ticket " + this.ticketingModel.ticketNumber + " has been Updated successfully");
                    this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                    this.getTicketById(this.ticketId, true);
                    this.resetVariables();
                }
                this.isSubmitted = false;
            }
        });
    }
    closeTicketById(ticketId: number, saveTicket: any) {
        this._customerservice.closeTicketById(ticketId, saveTicket).subscribe(response => {
            if (response) {
                let addedNotification: any = this._translatePipe.get("Ticket has been Closed successfully");
                this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                this.getTicketById(this.ticketId, true);
                this.resetVariables();
            }
        });
    }
    reopenTicketById(ticketId: number, saveTicket: any) {
        this._customerservice.reopenTicketById(ticketId, saveTicket).subscribe(response => {
            if (response) {
                let addedNotification: any = this._translatePipe.get("Ticket has been Reopened successfully");
                this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                this.getTicketById(this.ticketId, true);
                this.resetVariables();
            }
        });
    }

    attachFiles() {
        this.uploadFile();
    }
    uploadFile() {
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            let filelength = this.ticketingModel.attachments.length;
            let ticketNumber = this.ticketingModel.id;
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                filelength++;
                item.withCredentials = false;
                item.uploader.authToken = this._customerservice.getAuthorizationToken();
                const generateFileName = item.file.name + '_' + ticketNumber + '_' + filelength;
                form.append('fileName', decodeURIComponent(encodeURIComponent(generateFileName)));
                form.append('path', 'content/customer-service/' + this.ticketingModel.operatingCountryId + '/');
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
        else {
        }
    }
    downloadDocument(url: any, fileName: string) {
        let a = document.createElement('a');
        a.href = url;
        a.target = "_blank";
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    resetVariables() {
        this.showNoteReq = false;
        if (this.uploader) {
            this.uploader.queue = [];
        } else {
            this.uploader = [];
        }
        this.uploadResponse = [];
        this.count = 0;
    }
    goToViewTicket(isView: boolean) {
        if (isView) {
            this.showViewTicket = true;
            this.showEditTicket = false;
        }
    }
    onDateChange(date: any): any {
        this.ticketingModel.dueDate = date;
        this.ticketEditForm.controls['dueDate'].setValue(date);
    }
    onDateClear(): void {
        this.ticketEditForm.controls['dueDate'].setValue('');
    }
    /**
   * On Successful upload of file
   * @param item 
   * @param response 
   * @param status 
   * @param headers 
   */

    onSuccessItem(response: string): any {
        if (response) {
            let res = JSON.parse(response);
            let fileDetails = {
                "userId": this.userInfo.userId,
                "fileName": res.fileName,
                "url": res.url,
                "eTag": res.eTag,
                "key": res.key
            }
            this.uploadResponse.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                this.saveAttachments(this.uploadResponse);
            }

        }
        else {
            this._commonService.createNotification("", "File Not uploaded", NotificationType.ERROR);
        }
        this.ngProgress.done();
    }
    saveAttachments(attachments: any) {
        for (let i = 0; i < this.existFiles.length; i++) {
            let fileDetails = {
                "id": this.existFiles[i].id,
                "userId": this.userInfo.userId,
                "fileName": this.existFiles[i].fileName,
                "url": this.existFiles[i].url,
                "eTag": this.existFiles[i].eTag,
                "key": this.existFiles[i].key
            }
            attachments.push(fileDetails);
        }
   
        this._customerservice.saveAttachments(attachments, this.ticketingModel.id).subscribe(response => {
            if (response) {
                let res = response;
                let addedNotification: any = this._translatePipe.get("Ticket " + this.ticketingModel.ticketNumber + " has been Saved successfully");
                this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                this.uploader.queue = [];
                this.count = 0;
                this.uploadResponse = [];

                this.getTicketById(this.ticketingModel.id, true);

                this.resetVariables();
            }
        });
    }
    /**
     * failed to upload file
     * @param item 
     * @param response 
     * @param status 
     * @param headers 
     */
    onErrorItem(): any {
        this.ngProgress.done();
        this._commonService.createNotification("", "Failed to upload document. Please try after sometime ", NotificationType.ERROR);
    }

    subTypeChange(disputeTypeId: number, check: boolean) {
        if (disputeTypeId) {
            this._customerservice.getAllDepartmentsByOperatingCountryId(this.ticketingModel.operatingCountryId).subscribe(response => {
                if (response) {
                    this.departments = response;
                    this.users = [];

                    let addDepartment = true;
                    for (let i = 0; i < this.departments.length; i++) {
                        if (this.departments[i].id === this.ticketingModel.departmentId) {
                            addDepartment = false;
                        }
                    }
                    if (addDepartment) {
                        let appendDepartment = {
                            "id": this.ticketingModel.departmentId,
                            "name": this.ticketingModel.departmentName,
                            "value": this.ticketingModel.departmentName
                        };
                        this.departments.push(appendDepartment);
                    }
                    if (check) {
                        this.ticketEditForm.controls['department'].setValue('');
                        this.ticketEditForm.controls['assignedTo'].setValue('');
                        this.ticketEditForm.controls['assignToMe'].setValue(false);
                        this.setValidatorsForDueDate(false);

                    } else {
                        this.ticketEditForm.controls['department'].setValue(this.ticketingModel.departmentId);
                        this.getAssignedUsersByDepartments(this.ticketingModel.departmentId, false);

                    }

                } else {
                    this.departments = [];
                }
            });
            if (this.ticketEditForm && this.isDisputeTicket) {
                if (+disputeTypeId === DisputeTypesEnums.Dispute_Total_Order) {
                    this.isEntireOrder = true;
                    this.items = [];
                    this.ticketEditForm.controls["items"] = this._formbulider.array(this.items);
                    this.ticketEditForm.controls['orderReasonReasonId'].setValidators([Validators.required]);
                    this.ticketEditForm.controls['orderReasonReasonId'].updateValueAndValidity();
                    if (!(this.ticketEditForm.controls['orderReasonReasonId'].value === DisputeReason.Other)) {
                        this.showDisputeReasonField = false;
                        this.resetOrderReasonNotes(false);
                    }

                }
                else if (+disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
                    this.CreateIndividualOrderForm();
                    this.editForm();
                    this.isEntireOrder = false;
                    if (this.entireOrderType) {
                        this.ticketEditForm.controls["disputeType"].setValue(DisputeTypesEnums.Dispute_Individual_Order);
                        (this.ticketingModel.disputes && (this.ticketingModel.disputes.length > 0)) ? '' : this.CreateNewOrderForm();
                        this.ticketEditForm.controls["items"] = this._formbulider.array(this.items);
                    }
                    this.ticketEditForm.controls['orderReasonReasonId'].setValue("");
                    this.ticketEditForm.controls['orderReasonReasonId'].setValidators(null);
                    this.ticketEditForm.controls['orderReasonReasonId'].updateValueAndValidity();
                    this.ticketEditForm.controls["orderId"].setValue(this.ticketingModel.orderId);
                    this.ticketEditForm.controls['orderId'].setValidators([Validators.required]);
                    this.ticketEditForm.controls['orderId'].updateValueAndValidity();
                    let disputes: any[] = this.ticketEditForm.getRawValue().items;
                    if (!(disputes.find(item => (item.ticketDisputeReasonId === DisputeReason.Other) && ((+item.newDisputedQuantity) + (+item.alreadyDisputedQuantity)) > 0))) {
                        this.showDisputeReasonField = false;
                        this.resetOrderReasonNotes(false);
                    }

                }
            }

        } else {
            this.departments = [];
            this.users = [];
            this.ticketEditForm.controls['assignedTo'].setValue('');
            this.setValidatorsForDueDate(false);
            this.ticketEditForm.controls['assignToMe'].setValue(false);
            this.ticketEditForm.controls['department'].setValue('');
        }
    }



    assignToPermission: boolean;
    getAssignedUsersByDepartments(department: any, check: boolean) {
        let departmentId = +department;
        if (departmentId) {
            if (!this.userInfo.hasSystemRole) {
                this.isTicketClosePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[0] + "]"), AccessLevel.Department, departmentId);
                this.isTicketReopenPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[1] + "]"), AccessLevel.Department, departmentId);
                this.isTicketEditPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[2] + "]"), AccessLevel.Department, departmentId);
                this.isTicketSelfAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[3] + "]"), AccessLevel.Department, departmentId);
                this.isTicketReAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[4] + "]"), AccessLevel.Department, departmentId);
                this.isTicketAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[5] + "]"), AccessLevel.Department, departmentId);

                this.assignToPermission = this.ticketingModel.assignedToId ? this.isTicketReAssignPermission : this.isTicketAssignPermission;
            } else {
                this.isTicketClosePermission = true;
                this.isTicketReopenPermission = true;
                this.isTicketEditPermission = true;
                this.isTicketSelfAssignPermission = false;
                this.isTicketReAssignPermission = true;
                this.isTicketAssignPermission = true;
                this.assignToPermission = true;
            }

            if (this.ticketEditForm) {
                if (!this.assignToPermission) {
                    this.ticketEditForm.controls['assignedTo'].disable();
                } else {
                    this.ticketEditForm.controls['assignedTo'].enable();
                }
            }
            if (check) {
                this.ticketEditForm.controls['assignedTo'].setValue('');
                this.ticketEditForm.controls['assignToMe'].setValue(false);
                this.setValidatorsForDueDate(false);
            } else {
                if (this.ticketEditForm) {
                    this.ticketEditForm.controls['assignedTo'].setValue(this.ticketingModel.assignedToId ? this.ticketingModel.assignedToId:'');
                }
            }
            if (departmentId) {
                this._customerservice.getAssignedUsersByDepartments(departmentId).subscribe(response => {
                    if (response) {
                        this.users = response;
                        this.users = this.users.filter(function (item) { return item.id !== 1 });
                    } else {
                        this.users = [];
                    }
                });
            }
        } else {
            this.users = [];
            this.ticketEditForm.controls['assignedTo'].setValue('');
            this.ticketEditForm.controls['assignToMe'].setValue(false);
            this.setValidatorsForDueDate(false);
        }
    }

    getTicketById(ticketId: number, isView: boolean) {
        this.existFiles = [];
        this.orderInfo = null;
        this.orderSummary = null;
        this._customerservice.getTicketById(ticketId).subscribe((response) => {
            if (response) {
                this.ticketingModel = response;
                if (this.ticketingModel.notes) {
                    let notes = this.ticketingModel.notes;
                    this.ticketingModel.notes = notes.sort(function (a: any, b: any) {
                        let val = new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                        return val
                    });
                }
                this.ticketingModel.assignedToId = this.ticketingModel.assignedToId?this.ticketingModel.assignedToId:'';
                this.uploader = this._customerservice.getFileUploader();
                this.uploader.onErrorItem = () => this.onErrorItem();
                this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
                if (this.ticketingModel.statusId === Status.Closed) {
                    this.isTicketClosed = true;
                } else {
                    this.isTicketClosed = false;
                }
                
            
                if (this.ticketingModel.attachments) {
                    let attachments = this.ticketingModel.attachments;
                    this.existFiles = Object.assign([], attachments);
                    this.attachmentsLength = this.existFiles.length;
                }
                if (this.ticketingModel.operatingCountryId) {
                    this.departmentService.getTicketTypesAndSubTypes(this.ticketingModel.operatingCountryId).subscribe(response => {
                        if (response) {
                            this.ticketTypes = response;
                            if (this.ticketingModel.typeId === this.orderTypeId && (this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order || this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Total_Order)) {
                                this.getOrderDetails();
                                this.isDisputeTicket = true;
                                if (this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
                                    this.individualOrderType = true;
                                    this.entireOrderType = false;
                                }
                                else if (this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Total_Order) {
                                    this.individualOrderType = false;
                                    this.entireOrderType = true;
                                }
                            }
                            if (isView) {
                                this.showViewTicket = true;
                                this.showEditTicket = false;
                                if (this.ticketingModel.departmentId) {
                                    this.getAssignedUsersByDepartments(this.ticketingModel.departmentId, false);
                                }
                                if(this.focusNotes && this.focusNotes.nativeElement)
                                   this.focusNotes.nativeElement.focus();
                            } else {
                                this.showViewTicket = false;
                                this.showEditTicket = true;
                                this.editTicket();
                            }
                        }
                    });
                }
            }
        });
    }

    showNoteReq: boolean;
    checkNote() {
        if (this.noteModel.value) {
            this.showNoteReq = false;
        } else {
            this.showNoteReq = true;
        }
    }
    saveNote() {
        if (this.noteModel.value) {
            this.showNoteReq = false;
            this.noteModel.ticketId = this.ticketId;
            this.noteModel.createdBy = this.userInfo.userId;
            this._customerservice.saveNote(this.ticketId, this.noteModel).subscribe((response) => {
                if (response) {
                    this.noteModel = response;
                    let addedNotification: any = this._translatePipe.get("Note has been Added successfully");
                    this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                    this.noteModel = new NoteModel();
                    this.getTicketById(this.ticketId, true);
                }
            });
        } else {
            this.showNoteReq = true;
        }

    }
    getSubTypes(typeId: any, check: boolean) {
        let ticketTypeId = +typeId;
        if (ticketTypeId) {
            let types: any[] = JSON.parse(JSON.stringify(this.ticketTypes))
            this.subTypes = types.find(item => item.id === ticketTypeId).subTypes;
            this.departments = [];
            if (check) {
                this.ticketEditForm.controls['subType'].setValue('');
                this.ticketEditForm.controls['department'].setValue('');
                this.ticketEditForm.controls['assignedTo'].setValue('');
                this.ticketEditForm.controls['assignToMe'].setValue(false);
                this.setValidatorsForDueDate(false);
            } else {
                this.subTypeChange(this.ticketingModel.disputeTypeId, false);
            }
            if (!this.isDisputeTicket && +typeId === this.orderTypeId) {
                this.subTypes = this.subTypes.filter((item) => { return (item.id !== SubtypesEnums.Dispute && item.id !== SubtypesEnums.Cancel); })
            }
            if (ticketTypeId == this.orderTypeId) {
                this.showOrderField = true;
                this.ticketEditForm.controls['orderId'].setValidators([Validators.required]);
            } else {
                this.showOrderField = false;
            }
            if (ticketTypeId === this.productTypeId) {
                this.showLocationTypeField = true;
                this.ticketEditForm.controls['locationTypeId'].value ? '' : this.ticketEditForm.controls['locationTypeId'].setValue("");
                this.ticketEditForm.controls['locationTypeId'].setValidators([Validators.required]);
                this.ticketEditForm.controls['locationTypeId'].updateValueAndValidity();
            }
            else {
                this.showLocationTypeField = false;
                this.ticketEditForm.controls['locationTypeId'].setValidators(null);
                this.ticketEditForm.controls['locationTypeId'].updateValueAndValidity();
            }

            if (ticketTypeId === this.orderTypeId) {
                this.showOrderField = true;
                this.ticketEditForm.controls['orderId'].setValidators([Validators.required]);
            } else {
                this.ticketEditForm.controls['orderId'].clearValidators();
                this.ticketEditForm.controls['orderId'].updateValueAndValidity();
                this.showOrderField = false;
            }
        } else {
            this.showOrderField = false;
            this.subTypes = [];
            this.departments = [];
            this.users = [];
            this.ticketEditForm.controls['assignedTo'].setValue('');
            this.ticketEditForm.controls['subType'].setValue('');
            this.ticketEditForm.controls['assignToMe'].setValue(false);
            this.setValidatorsForDueDate(false);
            this.ticketEditForm.controls['department'].setValue('');
        }

    }

    getTicketTypes() {
        this._customerservice.getTicketTypes().subscribe((response) => {
            if (response) {
                this.ticketTypes = response;
            }
        });
    }
    getSourceTypes() {
        this._customerservice.getSourceTypes().subscribe((response) => {
            if (response) {
                this.sourceTypes = response;
                this.getTicketPriorities();
            }
        });
    }

    getTicketPriorities() {
        this._customerservice.getTicketPriorities().subscribe((response) => {
            if (response) {
                this.ticketPriorities = response;
                this.getTicketStatus();
            }
        });
    }

    getTicketStatus() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.statusTypes = response;
            }
        });
    }
    getDisputeReasons() {
        this._customerservice.getDisputeReasons().subscribe(response => {
            if (response) {
                this.disputeReasons = response;
            }
        });
    }
    /**
    * create item number
    * @returns FormGroup
    */
    createNewItemNumberGroup(productInfo: any): FormGroup {
        return this._formbulider.group({
            itemNumber: [productInfo.sku],
            quantity: [productInfo.quantity],
            productDescription: [productInfo.productDescription],
            alreadyDisputedQuantity: ['0'],
            newDisputedQuantity: ['0'],
            ticketDisputeReasonId: [''],
            include: new FormControl(false),
            createdBy: [this.userInfo.userId],
            modifiedBy: [""]
        });
    }

    CreateNewOrderForm() {
        this.items = [];
        for (let index = 0; index < this.orderInfo.length; index++) {
            this.items.push(this.createNewItemNumberGroup(this.orderInfo[index]));
        }
    }

    getOrderDetails() {
        if (this.ticketingModel.orderId) {
            this._customerservice.getOrderInfoUsingWebOrderNum(this.ticketingModel.orderId).subscribe(response => {
                if (response) {
                    this.orderSummary = response;
                    this.orderInfo = response.productInfo;
                }
            });
        }

    }
    // get location types and display when product is selected
    getLocationTypes() {
        this._customerservice.getLocationTypes().subscribe(response => {
            if (response) {
                this.locationTypes = response;
            }
        });
    }
    // if you click OK in the popup
    proceedToSave() {
        this.updateTicket();
    }
    /**
     * on clicking of "No" this method will be called.
    */
    cancel() {
        //data should not be removed...
    }
    //check for Dispute Quantity and show warning if it is a dispute ticket
    checkForValidationAndUpdate(createForm: any) {
        this.isSubmitted = true;
        if (this.ticketEditForm.valid) {
            let createTicketValues: any = this.ticketEditForm.getRawValue();
            if (this.isDisputeTicket && createTicketValues.disputeType == DisputeTypesEnums.Dispute_Individual_Order) {
                let disputes: any[] = createTicketValues.items;
                this.invalidQtyLineItems = "";
                if (disputes.filter(res => (res.alreadyDisputedQuantity + res.newDisputedQuantity) > res.quantity && res.newDisputedQuantity > 0).length > 0) {
                    this.invalidQtyLineItems = disputes.map(function (res) { if ((res.alreadyDisputedQuantity + res.newDisputedQuantity) > res.quantity && res.newDisputedQuantity > 0) { return res.itemNumber } }).join();
                    this.qtyWarning.toggle = true;
                    this.qtyWarning.message = "The number of disputed items for SKU# " + this.invalidQtyLineItems + " exceed the original quantity ordered. If this is correct, click Yes to proceed with this dispute.";
                }
                else {
                    this.updateTicket();
                }
            }
            else {
                this.updateTicket();
            }
        }
    }
    /*
    set Dispute reason for all selected line items
    */
    setReasonForAllItems(event: any) {
        const items: any = this.ticketEditForm.get('items');
        for (let index = 0; index < this.items.length; index++) {
            if (items.controls[index].controls['include'].value === true) {
                items.controls[index].controls['ticketDisputeReasonId'].setValue(event.target.value ? (+event.target.value) : event.target.value);
            }
        }
        this.onDisputeReasonChange();
    }
    /********
    * Deselect items when invalid quantity is entered 
   ********/

    deselectLineItem(index: number, items: any) {
        items.controls[index].controls['include'].setValue(false);
        items.controls[index].controls['newDisputedQuantity'].setValidators(null);
        items.controls[index].controls['newDisputedQuantity'].updateValueAndValidity();
        items.controls[index].controls['ticketDisputeReasonId'].setValidators(null);
        items.controls[index].controls['ticketDisputeReasonId'].updateValueAndValidity();
    }
    /********
     * mark items as selected 
    ********/
    markAsSelected(index: number, items: any) {
        items.controls[index].controls['include'].setValue(true);

        items.controls[index].controls['ticketDisputeReasonId'].setValidators([Validators.required]);
        items.controls[index].controls['ticketDisputeReasonId'].updateValueAndValidity();
    }
    /*
   when we use backspace and the input is empty, deselect the item
   */
    onBackspace(event: any, index: number) {
        const items: any = this.ticketEditForm.get('items');
        if (event.target.value === "" || +event.target.value === 0) {
            this.deselectLineItem(index, items);
        }
        this.onDisputeReasonChange();
    }
    /********
     * select items when a valid qty is entered
    ********/
    selectItem(event: any, index: number) {
        let inputChar = event.charCode ? String.fromCharCode(event.charCode) : event.target.value;
        const items: any = this.ticketEditForm.get('items');
        if (inputChar && Utils.validateNumericCharacterRule(inputChar) && (+inputChar > 0)) {
            this.markAsSelected(index, items);
        }
        else {
            +inputChar === 0 ? '' : event.preventDefault();
            if (event.target.value === "" || event.target.value === null || +event.target.value === 0 || +inputChar === 0) {
                this.deselectLineItem(index, items);
            }
        }
        this.onDisputeReasonChange();
    }
    /*
    on change on Dispute Reason
    */
    onDisputeReasonChange() {
        this.showDisputeReasonField = false;
        if (+this.ticketEditForm.controls['disputeType'].value === DisputeTypesEnums.Dispute_Total_Order) {
            if (+this.ticketEditForm.controls['orderReasonReasonId'].value === DisputeReason.Other) {
                this.ticketEditForm.controls['orderReasonNotes'].setValue("");
                this.ticketEditForm.controls['orderReasonNotes'].markAsUntouched();
                this.ticketEditForm.controls['orderReasonNotes'].setValidators([Validators.required]);
                this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
                this.showDisputeReasonField = true;
            }
            else {
                this.ticketEditForm.controls['orderReasonNotes'].setValue("");
                this.ticketEditForm.controls['orderReasonNotes'].markAsUntouched();
                this.ticketEditForm.controls['orderReasonNotes'].setValidators(null);
                this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
            }
        }
        else if (+this.ticketEditForm.controls['disputeType'].value === DisputeTypesEnums.Dispute_Individual_Order) {
            let disputes: any[] = this.ticketEditForm.getRawValue().items;
            if (disputes.find(item => (item.ticketDisputeReasonId === DisputeReason.Other) && ((+item.newDisputedQuantity) + (+item.alreadyDisputedQuantity)) > 0)) {
                this.resetOrderReasonNotes(true);
                this.showDisputeReasonField = true;
            }
            else {
                this.resetOrderReasonNotes(false);
            }
        }
    }
    /*
  set dispute reason details null
  */
    resetOrderReasonNotes(setValidators: boolean) {
        this.ticketEditForm.controls['orderReasonNotes'].setValue("");
        this.ticketEditForm.controls['orderReasonNotes'].markAsUntouched();
        setValidators ? this.ticketEditForm.controls['orderReasonNotes'].setValidators([Validators.required]) : this.ticketEditForm.controls['orderReasonNotes'].setValidators(null);
        this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
    }

    getTicketActivityLog() {
        if (this.ticketId > 0) {
            this._customerservice.getActivityLogByTicketId(this.ticketId).subscribe(response => {
                if (response) {
                    this.ticketActivityLogList = response;
                }
            });
        }
    }
    openTicketActivityModal(changedData: String) {
        if (changedData) {   
            this.ticketActivityChangeData=changedData;       
            this.ticketActivityDetailsModal.open();            
        } else {
           this.ticketActivityChangeData="";
        }
    }
   closeTicketActivityPopup() {
        this.ticketActivityDetailsModal.close();
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/view-work-ticket.component.ts